import ROUTES from '../../enums/routes';

// eslint-disable-next-line no-unused-vars
export default function getClientApNavigation(store) {
  return [
    {
      icon: 'mdi-clipboard-text-outline',
      title: 'AP ToBeCompleted',
      route: ROUTES.INCIDENTS_AP_FORMS,
    },
  ];
}
